import { CategoryBoxes } from './categoryBoxes'

export default CategoryBoxes
